import * as React from 'react';
import type { Equipment, CreateEquipmentPayload as Payload } from 'contracts/temperature-control/equipments';
import { api, handleApiError, applyQueryString } from 'services/api';

export const useCreateEquipment = () => {
  const createEquipment = React.useCallback(async (payload: Payload) => {
    try {
      const { data } = await api.post<Equipment>('equipments', payload);
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { createEquipment };
};
